import React from "react"
import { FormRow } from "./forms/common"
import Address from "./forms/Address"
import Email from "./forms/Email"
import Basic from "./forms/Basic"
import Phone from "./forms/Phone"
import Password from "./forms/Password"
import Race from "./forms/Race"
import Height from "./forms/Height"
import Weight from "./forms/Weight"

const ProfileForm = ({ ...props }) => (
  <React.Fragment>
    <Basic {...props} />
    {props.address && <Address {...props} />}
    {props.payForm && (
      <FormRow isEditing={props.dirty} last={props.loggedIn}>
        <Phone {...props} />
        {!props.loggedIn && <Email {...props} />}
      </FormRow>
    )}
    {props.payForm && !props.loggedIn && <Password {...props} />}
    {!props.payForm && (
      <React.Fragment>
        <Race {...props} />
        <FormRow isEditing={props.dirty} last>
          <Height {...props} />
          <Weight {...props} />
        </FormRow>
      </React.Fragment>
    )}
  </React.Fragment>
)

export { ProfileForm as default }



// WEBPACK FOOTER //
// ./assets/account/components/UserDetailsForm.js